import styled from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { textStyles } from "../../../shared/textStyles";
export const ItemContainer = styled.label.withConfig({
  displayName: "ItemContainer"
})(["all:initial;", ";cursor:default;display:block;flex:1;margin:", ";min-width:max-content;overflow:hidden;", ";", ";"], _ref => {
  let {
    size
  } = _ref;
  return tombac.text({
    fontSize: size === "xs" ? 12 : 14,
    color: "inherit"
  });
}, tombac.unit(0, 1), propStyling, textStyles);
//# sourceMappingURL=ItemContainer.js.map